import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { Table } from "react-bootstrap";
import { PostServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import * as Yup from "yup";

const GeneralMasterAdd = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("General Master Add"));
  }, []);

  const initialFormData = {
    Name: "",
    Description: "",
    IsSystem: 0,
    gmDetailLines: [
      {
        Name: "",
        Code: "",
        Description: "",
        IsInactive: 0,
      },
    ],
  };

  const [formData, setFormData] = useState(initialFormData);
  console.log("formData", formData);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState([]);

  const handleAddBrandLine = () => {
    const isAnyRowEmpty = formData?.gmDetailLines?.some(
      (row) => !row?.Code?.trim() || !row?.Name?.trim()
    );
  
    if (isAnyRowEmpty) {
      toast.error("Please fill the previous row before adding a new one.");
      return;
    }
  
    let newLineNo = 1;
    const existingLineNos = formData.gmDetailLines.map((row) => row.ID);
    while (existingLineNos.includes(newLineNo)) {
      newLineNo++;
    }
  
    setFormData((prevState) => ({
      ...prevState,
      gmDetailLines: [
        ...prevState.gmDetailLines,
        {
          Name: "",
          Code: "",
          Description: "",
          IsInactive: 0,
        },
      ],
    }));
  };
  
  const handleChange = async (e) => {
    const { name, checked, type } = e.target;
    const value = type === "checkbox" ? (checked ? 1 : 0) : e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    validateField(name, { ...formData, [name]: value });
  };

  const handleMaster = (e, index) => {
    const { name, checked, type } = e.target;
    const value = type === "checkbox" ? (checked ? 1 : 0) : e.target.value;
  
    const updatedLines = [...formData?.gmDetailLines];
    updatedLines[index] = {
      ...updatedLines[index],
      [name]: value,
    };
  
    const updatedFormData = { ...formData, gmDetailLines: updatedLines };
    setFormData(updatedFormData);
  
    if (errors[`gmDetailLines[${index}].${name}`]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[`gmDetailLines[${index}].${name}`];
        return newErrors;
      });
    }
  };
  

  const schema = Yup.object().shape({
    Name: Yup.string().required("Name is required"),
    gmDetailLines: Yup.array().of(
      Yup.object().shape({
        Code: Yup.string()
          .typeError("Code is required")
          .required("Code is required"),
          Name: Yup.string()
          .typeError("Name is required")
          .required("Name is required"),
      })
    ),
  });

  const validateField = async (fieldName, updatedData) => {
    try {
      await schema.validateAt(fieldName, updatedData);
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: "",
      }));
    } catch (err) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [fieldName]: err.message,
      }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validate the entire form including gmDetailLines
      await schema.validate(formData, { abortEarly: false });

      // If validation passes, proceed with the submit
      const response = await PostServiceCaller(
        `${API_URL}general-master`,
        formData,
        "post"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");
        setTimeout(() => {
          window.location.href = "/rujul/admin/general-master";
        }, 2000);
      } else {
        console.error(
          "Failed to submit data. Server responded with status:",
          response.status
        );
        console.error("Response data:", response.data);
      }
    } catch (err) {
      // Catch validation errors and set them in state
      if (err.inner) {
        const validationErrors = err.inner.reduce((acc, currError) => {
          acc[currError.path] = currError.message;
          return acc;
        }, {});
        setErrors(validationErrors); // Set errors in state
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Container" id="form-input-section">
      <form onSubmit={handleSubmit} id="formOne" className="rounded bg-white">
        <div className="row">
          <div className="col-md-4 flex-col">
            <div class="card">
              <div class="card-header">
                <h5 className="subheading">General Details</h5>
              </div>
              <div className="card-body">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label className="form-label">Code</label>
                      <input
                        type="text"
                        name="Code"
                        placeholder="Code"
                        className="form-control"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label className="form-label">
                        Name<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="Name"
                        placeholder="Name"
                        className="form-control"
                        value={formData?.Name}
                        onChange={(e) => handleChange(e)}
                      />
                      {errors.Name && (
                        <div className="text-danger">{errors.Name}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label className="form-label">Description</label>
                      <textarea
                        type="text"
                        name="Description"
                        placeholder="Description"
                        className="form-control"
                        value={formData?.Description}
                        onChange={(e) => handleChange(e)}
                      />
                    </div>
                  </div>
                  <div className="col-md-5 pt-5">
                    <label className="form-label">As System</label>
                    <input
                      className="form-check-input ms-2 "
                      type="checkbox"
                      name="IsSystem"
                      id="flexSwitchCheckChecked"
                      checked={formData.IsSystem === 1}
                      onChange={(e) => handleChange(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <div className="row">
              <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    style={{ color: "#2F2E4B" }}
                    id="assetCategory-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#assetCategory"
                    type="button"
                    role="tab"
                    aria-controls="assetCategory"
                    aria-selected="true"
                  >
                    Master Details
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link"
                    style={{ color: "#2F2E4B" }}
                    id="brandDetails-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#brandDetails"
                    type="button"
                    role="tab"
                    aria-controls="brandDetails"
                    aria-selected="false"
                  >
                    Sub Master Details
                  </button>
                </li>
              </ul>
              <div className="tab-content" id="myTabContent">
                {/** Main Form Code start */}
                <div
                  className="tab-pane fade show active"
                  id="assetCategory"
                  role="tabpanel"
                  aria-labelledby="assetCategory-tab"
                >
                  <div className="table-responsive brand-details rounded mt-2">
                    <button
                      type="button"
                      onClick={handleAddBrandLine}
                      className="custom-btn mb-2 pull-right btn btn-sm text-white"
                    >
                      <i class="fa fa-plus"></i>&nbsp;Add
                    </button>
                    <Table
                      style={{ background: "#ECECEC !important" }}
                      // id="poctable_head"
                      className="table table-bordered"
                    >
                      <thead
                        id="thcolor"
                        className="text-center align-middle  "
                      >
                        <tr>
                          <th className="col-2">
                            Code<span className="required">*</span>
                          </th>
                          <th>
                            Name<span className="required">*</span>
                          </th>
                          <th>Description</th>
                          <th>IsInActive</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData?.gmDetailLines?.map((ele, index) => (
                          <tr key={ele.ID}>
                            <td>
                              <input
                                type="text"
                                name="Code"
                                className="form-control"
                                value={ele?.Code || ""}
                                onChange={(e) => handleMaster(e, index)}
                              />
                              {errors[`gmDetailLines[${index}].Code`] && (
                                <span className="error">
                                  {errors[`gmDetailLines[${index}].Code`]}
                                </span>
                              )}
                            </td>
                            <td>
                              <input
                                type="text"
                                name="Name"
                                className="form-control"
                                value={ele?.Name || ""}
                                onChange={(e) => handleMaster(e, index)}
                              />
                              {errors[`gmDetailLines[${index}].Name`] && (
                                <span className="error">
                                  {errors[`gmDetailLines[${index}].Name`]}
                                </span>
                              )}
                            </td>
                            <td>
                              <input
                                type="text"
                                name="Description"
                                className="form-control"
                                value={ele?.Description || ""}
                                onChange={(e) => handleMaster(e, index)}
                              />
                            </td>
                            <td className="text-center align-middle">
                              <input
                                type="checkbox"
                                name="IsInactive"
                                checked={ele.IsInactive}
                                className="form-check-input"
                                onChange={(e) => handleMaster(e, index)}
                              />
                            </td>
                            <td className="text-center align-middle">
                              <i
                                className="fa fa-trash"
                                style={{
                                  fontSize: "1.2rem",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setFormData((prevState) => ({
                                    ...prevState,
                                    gmDetailLines:
                                      prevState.gmDetailLines.filter(
                                        (_, i) => i !== index
                                      ),
                                  }));
                                }}
                              ></i>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
                <div
                  className="tab-pane fade show p-2"
                  id="brandDetails"
                  role="tabpanel"
                  aria-labelledby="brandDetails-tab"
                >
                  Coming Soon
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <div className="d-flex me-2">
            <div>
              <button
                type="button"
                className="cancel-btn me-2"
                onClick={() =>
                  (window.location.href = "/rujul/admin/general-master")
                }
              >
                Cancel
              </button>
            </div>
            <div>
              <button type="submit" className="custom-btn">
                {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default GeneralMasterAdd;
